/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const featureFlagSchema = z.object({
  id: z.number().int(),
  key: z.string(),
  value: z.string(),
  enabled: z.boolean(),
  createdAt: z.number(),
  updatedAt: z.number(),
});

export type IFeatureFlag = z.infer<typeof featureFlagSchema>;
